import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { styled } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';
import LinearProgress, { linearProgressClasses } from '@mui/material/LinearProgress';
import { useTokens } from '@mcn-platform/models';
import TextCircle from '../TextCircle';
const CustomLinearProgress = styled(LinearProgress)(({ theme }) => ({
    height: '5px !important',
    minWidth: '100px',
    //   marginBottom: theme.spacing(0.5),
    borderRadius: theme.spacing(0.3125),
    [`&.${linearProgressClasses.colorPrimary}`]: {
        backgroundColor: theme.portal.courseDeliveryPage?.courseProgressBarColor || theme.palette.lightBlue[300],
    },
    [`& .${linearProgressClasses.bar}`]: {
        backgroundColor: theme.portal.courseDeliveryPage?.courseProgressIconColor || theme.palette.success.main,
    },
}));
const ProgressLinear = ({ value, showTitle }) => {
    const tokens = useTokens();
    return (_jsxs(Box, { sx: {
            width: '100%',
            display: 'flex',
            flexDirection: 'row',
            minHeight: 28,
        }, children: [showTitle && (_jsx(Box, { children: _jsx(Typography, { className: "courseInfoBarLabel", sx: { fontSize: { xs: '14px', md: '16px' } }, variant: "subtitle1", children: tokens.getToken('progressLabel') }) })), _jsx(Box, { sx: {
                    mt: 'auto',
                    mb: 'auto',
                    ml: 2.5,
                    flex: 1,
                    marginLeft: '40px',
                    height: '100%',
                }, children: _jsxs(Box, { sx: { position: 'relative' }, children: [_jsx(CustomLinearProgress, { variant: "determinate", value: value }), _jsx(Box, { sx: {
                                width: '100%',
                                position: 'absolute',
                                top: (theme) => theme.spacing(-2.5),
                                transition: 'transform .4s linear',
                                transform: (theme) => `translateX(calc(${value}% - ${theme.spacing(3)}))`,
                            }, children: _jsx(TextCircle, { innerText: `${value}%`, className: "courseProgressIconColor" }) })] }) })] }));
};
ProgressLinear.defaultProps = {
    showTitle: true,
};
export default ProgressLinear;
//# sourceMappingURL=ProgressLinear.js.map